// src/views/ExampleImages.js
import React from 'react';
import { Box, Typography, ImageList, ImageListItem, ImageListItemBar, IconButton } from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

const exampleImageData = [
  {
    img: '/img/demo_image_1974.jpg',
    title: '1974',
    author: 'Joachim, Put It in the Machine',
  },
  {
    img: '/img/demo_image_1997.jpg',
    title: '1997',
    author: 'Blaník',
  },
  {
    img: '/img/demo_image_2021.jpg',
    title: '2021',
    author: 'Akt',
  },
];

const ExampleImages = ({ onExampleSelect }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" align="center" gutterBottom>
        Select an example
      </Typography>
      {/* --- Adjusted height and rowHeight to make it shorter --- */}
      <ImageList sx={{ width: '100%', height: 160 }} cols={3} rowHeight={160}>
        {exampleImageData.map((item) => (
          <ImageListItem key={item.img} sx={{
            cursor: 'pointer',
            '& .MuiImageListItem-img': {
                transition: 'transform 0.3s ease-in-out',
            },
            '&:hover .MuiImageListItem-img': {
                transform: 'scale(1.05)',
            },
            '& .MuiImageListItemBar-root': {
                transition: 'background 0.3s ease-in-out',
            },
            '&:hover .MuiImageListItemBar-root': {
                background: 'rgba(0, 0, 0, 0.7)',
            }
          }}>
            <img
              // Note: The query parameters for cropping are less important for local files
              // but are kept here for consistency.
              src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
              srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
              alt={item.title}
              loading="lazy"
              onClick={() => onExampleSelect(item.img, item.title)}
            />
            <ImageListItemBar
              title={item.title}
              subtitle={item.author}
              actionIcon={
                <IconButton
                  sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                  aria-label={`info about ${item.title}`}
                  onClick={() => onExampleSelect(item.img, item.title)}
                >
                  <AddPhotoAlternateIcon />
                </IconButton>
              }
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
};

export default ExampleImages;